import React, { Component } from 'react'
import AppContext from "@lightspeed-invoicing/core-client/frontend/app/Context";
import Icon from "../icon/icon.component.jsx";
import ActionButton from "../button/actionbutton.component.jsx";
import CustomerSelect from "../../customer/selection.component.jsx";
const uuidv4 = require('uuid/v4')

class InlineEditContact extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            contactId: this.props.value,
            formClassName: this.props.formClassName || '',
            filters: this.props.filters || {},
            contactName: '',
            contactType: this.props.contactType || '',
            endPoint: this.props.endPoint || '',
            field: this.props.field || '',
            uniqueId: uuidv4(),
            editable: this.props.editable || false,
            editMode: false,
            hover: false,
            onChange: this.props.onChange || function () { },
            success: false,
        }
        this.handleUserSelectChange = this.handleUserSelectChange.bind(this)
        this.triggerEdit = this.triggerEdit.bind(this)
        this.save = this.save.bind(this)
        this.onMouseEnterHandler = this.onMouseEnterHandler.bind(this)
        this.onMouseLeaveHandler = this.onMouseLeaveHandler.bind(this)
    }


    componentWillReceiveProps(nextProps) {
        const currentContactId = this.state.contactId
        this.setState({
            contactId: nextProps.value,
            endPoint: nextProps.endPoint || '',
            contactType: nextProps.contactType || '',
            field: nextProps.field || '',
        }, () => {
            if (currentContactId !== this.state.contactId) {
                this.loadName()
            }
        })
    }

    loadName() {
        if (!this.state.contactId) {
            return
        }
        AppContext.getApiClient().get('/contacts/' + this.state.contactId).then(res => {
            this.setState({
                contactName: res.attributes.name,
            })
        })
    }

    componentDidMount() {
        if (!this.state.contactName) {
            this.loadName()
        }
    }

    onMouseEnterHandler() {
        this.setState({
            hover: true
        });
    }

    onMouseLeaveHandler() {
        this.setState({
            hover: false
        });
    }

    triggerEdit(event) {
        event?.preventDefault()
        this.setState({
            editMode: !this.state.editMode
        })
    }

    handleUserSelectChange(userId) {
        this.setState({
            sellerId: userId,
        })
    }

    save(event) {
        event.preventDefault()
        AppContext.getApiClient().patch(this.state.endPoint, {
            [this.state.field]: this.state.contactId,
        }).then((r) => {
            this.setState({
                editMode: false,
                success: !r.error,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        success: false,
                    })
                }, 1500)
            })
            this.loadName()
        })
    }

    render() {
        let contactName = this.state.contactName
        if (this.state.editable) {
            let link = <a href={'#'} onClick={this.triggerEdit} onMouseEnter={this.onMouseEnterHandler} onMouseLeave={this.onMouseLeaveHandler}>
                {contactName} {!this.state.success ? <Icon value={'pencil-alt'} className={'ml-1 ' + (!this.state.hover ? 'text-gray' : '')} /> :
                    <Icon value={'check'} className={'ml-1 ' + (!this.state.hover ? 'text-success short-fade-out' : '')} />}
            </a>
            contactName = <span>
                {link}
                <div className={"dropdown-menu p-4 " + (this.state.editMode ? 'show ' : '') + this.state.formClassName} style={{ width: '350px' }}>
                    <div className="w-100 m-0">
                        <CustomerSelect
                            filters={this.state.filters}
                            contactType={this.state.contactType}
                            value={this.state.contactId}
                            onChange={id => { this.setState({ contactId: id }) }}
                            className="form-control"
                        />
                    </div>
                    <p className="m-0 pt-2">
                        <button className="btn btn-sm btn-outline-secondary" onClick={this.triggerEdit}>
                            <Icon value={"arrow-left"} />
                        </button>
                        <ActionButton className="btn btn-sm btn-outline-primary ml-2" onClick={this.save}>
                            <Icon value={"save"} />
                        </ActionButton>
                    </p>
                </div>
            </span>
        }

        return contactName
    }

}

export default InlineEditContact





// WEBPACK FOOTER //
// ./src/common/inline-edit/contact.component.jsx